export default {
    path: '/userControl',
    name: 'UserControl',
    component: () => import('@/layout/index.vue'),
    // redirect: {
    //     name: "EquipmentMasterData"
    // },
    meta: {
        title: '系统管理',
        icon: 'iconfont el-icon-setting',
        role: 'BACK_MENU8'
    },
    children: [{
            path: '/testSysRole',
            name: 'TestSysRole',
            component: () => import('@/views/User/testSysRole.vue'),
            meta: {
                title: '角色管理',
                role: 'BACK_MENU8_M1'
            }
        },
        {
            path: '/testSysUser',
            name: 'TestSysUser',
            component: () => import('@/views/User/testSysUser.vue'),
            meta: {
                title: '用户管理',
                role: 'BACK_MENU8_M2'
            }
        },
        {
            path: '/authority',
            name: 'Authority',
            component: () => import('@/views/User/testAuthority.vue'),
            meta: {
                title: '权限管理',
                role: 'BACK_MENU8_M3'
            }
        },
        {
            path: '/log',
            name: 'Log',
            component: () => import('@/views/User/log.vue'),
            meta: {
                title: '日志管理',
                role: 'BACK_MENU8_M4'
            }
        },
        {
            path: '/emailConfig',
            name: 'emailConfig',
            component: () => import('@/views/User/emailConfig.vue'),
            meta: {
                title: '邮箱配置管理',
                role: 'BACK_MENU8_M5'
            }
        },
    ],
}